import { ROUTE_PATHS } from "../../common/enums/routing-enums";

export const WHOS_NEW_SUB_ROUTES = [`${ROUTE_PATHS.WHOS_NEW_ACTION_REPORT}/tree`];
